import { Directive, Input, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: "[formControlName], [formControl]"
})
export class FieldNameToFormControlProviderDirective implements OnInit {
	@Input() public name?: string;
	constructor(private ngControl: NgControl) { }

	public ngOnInit(): void {
		if (this.ngControl.control)
			(this.ngControl.control as any).controlName = this.name;
	}
}
